import { columnHelper } from './helper';

export const location = columnHelper.accessor('location', {
  header: 'Location',
});
